var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhoAreYouWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 104,
    viewBox: "0 0 115 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9005 31.4501C42.0005 29.2501 36.9005 28.1501 31.8005 28.3501H23.8005V29.6501C22.3005 30.1501 20.9005 30.7501 19.6005 31.4501C12.4005 35.6501 12.4005 42.4501 19.7005 46.6501C21.0005 47.3501 22.3005 47.9501 23.8005 48.4501V49.8501H33.3005C37.9005 49.7501 42.4005 48.7501 45.9005 46.7501C53.2005 42.4501 53.2005 35.6501 45.9005 31.4501Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 46.65C7.8 44.55 6 41.75 6 38.95V32.65C6 35.45 7.8 38.15 11.5 40.35C18.8 44.55 30.5 44.55 37.8 40.35C41.4 38.25 43.2 35.55 43.2 32.75V39.05C43.2 41.75 41.4 44.55 37.8 46.65C30.6 50.85 18.8 50.85 11.5 46.65Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6008 40.35C4.30085 36.15 4.30085 29.35 11.5008 25.15C18.7008 20.95 30.5009 20.95 37.8008 25.15C45.1008 29.35 45.1008 36.15 37.9008 40.35C30.6008 44.55 18.8008 44.55 11.6008 40.35Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 31.8499L20.4 32.5499L20.9 29.45H17.1L16 35.0499L34.2 34.0499V31.8499Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 59.4501C101 57.2501 95.9005 56.1501 90.8005 56.3501H82.8005V57.6501C81.3005 58.1501 79.9005 58.7501 78.6005 59.4501C71.4005 63.6501 71.4005 70.4501 78.7005 74.6501C80.0005 75.3501 81.3005 75.9501 82.8005 76.4501V77.8501H92.3005C96.9005 77.7501 101.4 76.7501 104.9 74.7501C112.2 70.4501 112.2 63.6501 104.9 59.4501Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 74.65C66.8 72.55 65 69.75 65 66.95V60.65C65 63.45 66.8 66.15 70.5 68.35C77.8 72.55 89.5 72.55 96.8 68.35C100.4 66.25 102.2 63.55 102.2 60.75V67.05C102.2 69.75 100.4 72.55 96.8 74.65C89.6 78.85 77.8 78.85 70.5 74.65Z",
    fill: "#292929"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6008 68.35C63.3008 64.15 63.3008 57.35 70.5008 53.15C77.7008 48.95 89.5009 48.95 96.8008 53.15C104.101 57.35 104.101 64.15 96.9008 68.35C89.6008 72.55 77.8008 72.55 70.6008 68.35Z",
    fill: "url(#paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2 59.8499L79.4 60.5499L79.9 57.45H76.1L75 63.0499L93.2 62.0499V59.8499Z",
    fill: "url(#paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 22.15C105.6 19.95 100.5 18.85 95.4005 19.05H77.8005V20.35C76.3005 20.85 74.9005 21.45 73.6005 22.15C66.4005 26.35 66.4005 33.15 73.7005 37.35C75.0005 38.05 76.3005 38.65 77.8005 39.15V40.55H97.0004C101.6 40.45 106.1 39.45 109.6 37.45C116.8 33.15 116.8 26.35 109.5 22.15Z",
    fill: "url(#paint6_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 24.65C61.8 22.55 60 19.75 60 16.95V10.65C60 13.45 61.8 16.15 65.5 18.35C72.8 22.55 84.5 22.55 91.8 18.35C95.4 16.25 97.2 13.5501 97.2 10.7501V17.05C97.2 19.75 95.4 22.55 91.8 24.65C84.6 28.85 72.8 28.85 65.5 24.65Z",
    fill: "#292929"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 31.05C61.8 28.95 60 26.15 60 23.35V17.05C60 19.85 61.8 22.5501 65.5 24.7501C72.8 28.9501 84.5 28.9501 91.8 24.7501C95.4 22.6501 97.2 19.95 97.2 17.15V23.45C97.2 26.15 95.4 28.95 91.8 31.05C84.6 35.25 72.8 35.25 65.5 31.05Z",
    fill: "#F1ECEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 37.35C61.8 35.25 60 32.45 60 29.65V23.35C60 26.15 61.8 28.85 65.5 31.05C72.8 35.25 84.5 35.25 91.8 31.05C95.4 28.95 97.2 26.25 97.2 23.45V29.75C97.2 32.45 95.4 35.25 91.8 37.35C84.6 41.55 72.8 41.55 65.5 37.35Z",
    fill: "#292929"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4993 18.35C58.1993 14.15 58.1993 7.35 65.3993 3.15C72.5993 -1.05 84.3993 -1.05 91.6993 3.15C98.9993 7.35 98.9993 14.15 91.7993 18.35C84.5993 22.55 72.7993 22.55 65.4993 18.35Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2 9.85004L74.4 10.55L74.8 7.55005H71L70 13.15L88.2 12.05V9.85004Z",
    fill: "#59595B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 103.2L31.1 94.2V76L15.5 84.9V103.2Z",
    fill: "#292929"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 103.2L0 94.2V76L15.5 84.9V103.2Z",
    fill: "#313131"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 84.9L0 76L15.5 67L31.1 76L15.5 84.9Z",
    fill: "#313131"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4996 76L15.4996 72.5L9.59961 76L15.4996 79.4L21.4996 76Z",
    fill: "url(#paint7_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9005 31.4501C42.0005 29.2501 36.9005 28.1501 31.8005 28.3501H23.8005V29.6501C22.3005 30.1501 20.9005 30.7501 19.6005 31.4501C12.4005 35.6501 12.4005 42.4501 19.7005 46.6501C21.0005 47.3501 22.3005 47.9501 23.8005 48.4501V49.8501H33.3005C37.9005 49.7501 42.4005 48.7501 45.9005 46.7501C53.2005 42.4501 53.2005 35.6501 45.9005 31.4501Z",
    fill: "url(#paint8_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 46.65C7.8 44.55 6 41.75 6 38.95V32.65C6 35.45 7.8 38.15 11.5 40.35C18.8 44.55 30.5 44.55 37.8 40.35C41.4 38.25 43.2 35.55 43.2 32.75V39.05C43.2 41.75 41.4 44.55 37.8 46.65C30.6 50.85 18.8 50.85 11.5 46.65Z",
    fill: "#292929"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6008 40.35C4.30085 36.15 4.30085 29.35 11.5008 25.15C18.7008 20.95 30.5009 20.95 37.8008 25.15C45.1008 29.35 45.1008 36.15 37.9008 40.35C30.6008 44.55 18.8008 44.55 11.6008 40.35Z",
    fill: "url(#paint9_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 31.8499L20.4 32.5499L20.9 29.45H17.1L16 35.0499L34.2 34.0499V31.8499Z",
    fill: "url(#paint10_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 59.4501C101 57.2501 95.9005 56.1501 90.8005 56.3501H82.8005V57.6501C81.3005 58.1501 79.9005 58.7501 78.6005 59.4501C71.4005 63.6501 71.4005 70.4501 78.7005 74.6501C80.0005 75.3501 81.3005 75.9501 82.8005 76.4501V77.8501H92.3005C96.9005 77.7501 101.4 76.7501 104.9 74.7501C112.2 70.4501 112.2 63.6501 104.9 59.4501Z",
    fill: "url(#paint11_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 74.65C66.8 72.55 65 69.75 65 66.95V60.65C65 63.45 66.8 66.15 70.5 68.35C77.8 72.55 89.5 72.55 96.8 68.35C100.4 66.25 102.2 63.55 102.2 60.75V67.05C102.2 69.75 100.4 72.55 96.8 74.65C89.6 78.85 77.8 78.85 70.5 74.65Z",
    fill: "#292929"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6008 68.35C63.3008 64.15 63.3008 57.35 70.5008 53.15C77.7008 48.95 89.5009 48.95 96.8008 53.15C104.101 57.35 104.101 64.15 96.9008 68.35C89.6008 72.55 77.8008 72.55 70.6008 68.35Z",
    fill: "url(#paint12_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2 59.8499L79.4 60.5499L79.9 57.45H76.1L75 63.0499L93.2 62.0499V59.8499Z",
    fill: "url(#paint13_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 22.15C105.6 19.95 100.5 18.85 95.4005 19.05H77.8005V20.35C76.3005 20.85 74.9005 21.45 73.6005 22.15C66.4005 26.35 66.4005 33.15 73.7005 37.35C75.0005 38.05 76.3005 38.65 77.8005 39.15V40.55H97.0004C101.6 40.45 106.1 39.45 109.6 37.45C116.8 33.15 116.8 26.35 109.5 22.15Z",
    fill: "url(#paint14_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 24.65C61.8 22.55 60 19.75 60 16.95V10.65C60 13.45 61.8 16.15 65.5 18.35C72.8 22.55 84.5 22.55 91.8 18.35C95.4 16.25 97.2 13.5501 97.2 10.7501V17.05C97.2 19.75 95.4 22.55 91.8 24.65C84.6 28.85 72.8 28.85 65.5 24.65Z",
    fill: "#292929"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 31.05C61.8 28.95 60 26.15 60 23.35V17.05C60 19.85 61.8 22.5501 65.5 24.7501C72.8 28.9501 84.5 28.9501 91.8 24.7501C95.4 22.6501 97.2 19.95 97.2 17.15V23.45C97.2 26.15 95.4 28.95 91.8 31.05C84.6 35.25 72.8 35.25 65.5 31.05Z",
    fill: "#F1ECEC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 37.35C61.8 35.25 60 32.45 60 29.65V23.35C60 26.15 61.8 28.85 65.5 31.05C72.8 35.25 84.5 35.25 91.8 31.05C95.4 28.95 97.2 26.25 97.2 23.45V29.75C97.2 32.45 95.4 35.25 91.8 37.35C84.6 41.55 72.8 41.55 65.5 37.35Z",
    fill: "#292929"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4993 18.35C58.1993 14.15 58.1993 7.35 65.3993 3.15C72.5993 -1.05 84.3993 -1.05 91.6993 3.15C98.9993 7.35 98.9993 14.15 91.7993 18.35C84.5993 22.55 72.7993 22.55 65.4993 18.35Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2 9.85004L74.4 10.55L74.8 7.55005H71L70 13.15L88.2 12.05V9.85004Z",
    fill: "#59595B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 103.2L31.1 94.2V76L15.5 84.9V103.2Z",
    fill: "#292929"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 103.2L0 94.2V76L15.5 84.9V103.2Z",
    fill: "#313131"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 84.9L0 76L15.5 67L31.1 76L15.5 84.9Z",
    fill: "#313131"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4996 76L15.4996 72.5L9.59961 76L15.4996 79.4L21.4996 76Z",
    fill: "url(#paint15_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.246,
    y1: 39.0354,
    x2: 51.398,
    y2: 39.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4265,
    stopColor: "#C4C9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    stopColor: "#D7DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 24.7008,
    y1: 22,
    x2: 24.7008,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 34.2,
    y1: 31.7748,
    x2: 30.074,
    y2: 44.1375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 73.246,
    y1: 67.0354,
    x2: 110.398,
    y2: 67.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4265,
    stopColor: "#C4C9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    stopColor: "#D7DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 83.7008,
    y1: 50,
    x2: 83.7008,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 93.2,
    y1: 59.7748,
    x2: 89.074,
    y2: 72.1375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 91.6005,
    y1: 19.0269,
    x2: 91.6005,
    y2: 40.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 15.5496,
    y1: 72.5,
    x2: 15.5496,
    y2: 79.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 14.246,
    y1: 39.0354,
    x2: 51.398,
    y2: 39.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4265,
    stopColor: "#C4C9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    stopColor: "#D7DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 24.7008,
    y1: 22,
    x2: 24.7008,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 34.2,
    y1: 31.7748,
    x2: 30.074,
    y2: 44.1375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 73.246,
    y1: 67.0354,
    x2: 110.398,
    y2: 67.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4265,
    stopColor: "#C4C9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    stopColor: "#D7DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 83.7008,
    y1: 50,
    x2: 83.7008,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 93.2,
    y1: 59.7748,
    x2: 89.074,
    y2: 72.1375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 91.6005,
    y1: 19.0269,
    x2: 91.6005,
    y2: 40.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 15.5496,
    y1: 72.5,
    x2: 15.5496,
    y2: 79.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoAreYouWidget);
export default __webpack_public_path__ + "static/media/who-are-you-widget.11d4e5deb4948feb9670410e058ff086.svg";
export { ForwardRef as ReactComponent };